const btn_location = document.querySelector('#btn-use-my-location')
const btn_address = document.querySelector('#btn-open-modal')
const btn_close_modal = document.querySelector('#btn-close-modal')
const modal = document.querySelector('#modal-location')
const input_address = document.querySelector('#input-address')

const key = 'AIzaSyBOQizOE7KWimZ0WtOQzQykHiB2lAERldM'

if (!btn_location) {
  return
}

btn_location.addEventListener('click', function () {
  btn_location.disabled = true
  btn_location.querySelector('span').textContent = 'Carregando...'

  navigator.geolocation.getCurrentPosition(function (position) {
    const lat = position.coords.latitude
    const lng = position.coords.longitude

    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${key}`

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const address = data.results[0].formatted_address
        window.location.href = `/onde-encontrar/?address=${address}&lat=${lat}&lng=${lng}`
      })
  })
})

btn_address.addEventListener('click', function () {
  modal.showModal()
})

btn_close_modal.addEventListener('click', function () {
  modal.close()
})

// search on google maps when typing and show dropdown with address
var autocomplete = new google.maps.places.Autocomplete(input_address, {
  types: ['geocode'],
  componentRestrictions: { country: 'br' },
  fields: ['address_components', 'geometry'],
})

// get lat and lng after selecting an address
autocomplete.addListener('place_changed', function () {
  var place = autocomplete.getPlace()

  var lat = place.geometry.location.lat()
  var lng = place.geometry.location.lng()
  document.querySelector('#modal-location #lat').value = lat
  document.querySelector('#modal-location #lng').value = lng
})

input_address.addEventListener('focus', function () {
  var pacContainer = document.querySelector('.pac-container')
  input_address.parentElement.appendChild(pacContainer)
})
